export const LoadingSkeleton = ({ count = 5 }) => {
  return (
    <div className="space-y-4" data-testid="loading-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div 
          key={i}
          className="bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-lg overflow-hidden animate-pulse"
        >
          <div className="flex items-stretch">
            {/* Date section */}
            <div className="flex flex-col items-center justify-center px-4 py-4 bg-slate-50 dark:bg-slate-800/50 min-w-[80px]">
              <div className="w-8 h-3 bg-slate-200 dark:bg-slate-700 rounded mb-2" />
              <div className="w-10 h-8 bg-slate-200 dark:bg-slate-700 rounded" />
            </div>
            
            {/* Info section */}
            <div className="flex-1 p-4">
              <div className="flex items-start justify-between gap-2">
                <div className="flex-1">
                  <div className="w-3/4 h-6 bg-slate-200 dark:bg-slate-700 rounded mb-2" />
                  <div className="w-1/2 h-4 bg-slate-200 dark:bg-slate-700 rounded" />
                </div>
                <div className="w-16 h-6 bg-slate-200 dark:bg-slate-700 rounded-full" />
              </div>
              
              <div className="flex items-center gap-2 mt-3">
                <div className="w-12 h-5 bg-slate-200 dark:bg-slate-700 rounded" />
                <div className="w-12 h-5 bg-slate-200 dark:bg-slate-700 rounded" />
                <div className="w-12 h-5 bg-slate-200 dark:bg-slate-700 rounded" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;
